export const REMOVE_FAVORITE_VENUE = 'REMOVE_FAVORITE_VENUE'
export const REMOVE_FAVORITE_VENUE_SUCCESS = 'REMOVE_FAVORITE_VENUE_SUCCESS'
export const REMOVE_FAVORITE_VENUE_ERROR = 'REMOVE_FAVORITE_VENUE_ERROR'

export const RemoveFavoriteVenue = (data) => ({
  type: REMOVE_FAVORITE_VENUE,
  payload: data
})
